export default __webpack_public_path__ + "static/KFZapp_1-b2e982e80535f044d913f8889b9894a1.png";